export default __webpack_public_path__ + "static/media/rocket_anim_15.4536af70.png";